import type { Signal } from "@suse-o11y/signal";
import { createContext } from "react";

import type { ImmutableMap } from "~/tools/immutable-map";

export interface DashboardState {
	/**
	 * It is essential to store the virtualized widgets states in the dashboard so that
	 * they preserve their state even when virtualization unmounts them.
	 */
	widgets: Signal<ImmutableMap<string, unknown>>;
}

export const DashboardContext = createContext<null | DashboardState>(null);

/**
 * Provides the widget identifier to associate state with a specific dashboard widget in {@link DashboardState.widgets}.
 */
export const DashboardWidgetContext = createContext<null | string>(null);
